import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import React from "react";
import { useDispatch } from "react-redux";
import { setShowQuizModal } from "../../redux/personaliseLessons/lessonQuizSlice";

const QuizCompletionModal = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setShowQuizModal(false));
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClick}
        as="div"
        className="fixed inset-0 z-[50] flex flex-col items-center justify-center"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-0" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="relative z-[9999999] w-[90%] max-w-lg rounded-xl border bg-secondary_background p-4 text-white">
          <div
            className="absolute top-3 right-3 cursor-pointer"
            onClick={handleClick}
          >
            <FontAwesomeIcon icon={faXmark} className="text-2xl" />
          </div>
          <div className="mx-auto h-[110px] w-[180px] lg:h-[181px] lg:w-[298px]">
            <img
              src="https://img.learntube.ai/public-assets/Lead%20Generation/Group.png?updatedAt=1713420806381"
              alt=""
              className="h-full w-full"
            />
          </div>
          <h3 className="mt-6 text-center font-semibold leading-5">
            Submit all the quizzes from previous modules to mark them as
            complete.
          </h3>
          <p className="mt-3 text-center text-xs text-white/50">
            Course completion requires all quizzes to be finished.
          </p>
        </div>
      </Dialog>
    </div>
  );
};

export default QuizCompletionModal;
